<template>
    <div class="bblist">
        <el-card>
            <van-cell title="日期" :value="date" @click="show = true" style="padding:0" />
            <van-calendar v-model="show" type="range" @confirm="onConfirm" :min-date="minDate" />

            <main>
                <h4 style="color:#F56C6C;font-size:14px;margin-bottom:10px">
                    <span>{{ org }}</span>    
                    <van-button type="info" size="mini" @click="daoChu()">打印</van-button>
                </h4>
                <span style="font-size: 14px;">车辆总数：<span style="color:#F56C6C;font-weight:600">{{ carnum }}</span></span>
                <span style="font-size: 14px;margin-left:20px">加油车辆：<span style="color:#F56C6C;font-weight:600">{{ carnum_jiayou }}</span></span>
            </main>
            <br/>

            <br/>

            <el-table
                algin=center
                stripe
				id='outTable'
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list"
                @row-click="(row,column,e)=>go(row)">
                <el-table-column
                    type="index"
                    fixed
                    width="50">
                </el-table-column>
                
                <el-table-column 
                    width="90"
                    prop="chepai"
                    fixed
                    label="车牌号" >
                </el-table-column>

                <el-table-column
                    width="60"
                    prop="xz_status"
                    label="状态">
                </el-table-column>

                <el-table-column 
                    prop="cishu"
                    width="50"
                    :render-header="renderHeader1"
                    label="次数">
                </el-table-column>

                <el-table-column 
                    width="80"
                    prop="all_shengshu"
                    :render-header="renderHeader2"
                    label="总升数">
                </el-table-column>
      
                <el-table-column 
                    width="80"
                    prop="all_licheng"
                    :render-header="renderHeader3"
                    label="总里程">
                </el-table-column>

                <el-table-column
                    width="60"
                    prop="youhao"
                    label="标准">
                </el-table-column>

                <el-table-column
                    width="70"
                    prop="pjyh"
                    label="平均">
                </el-table-column>
                    
                <el-table-column label="差异" width="70" :render-header="renderHeader4">
                    <template slot-scope="scope">
                        <span :style="[{color:((scope.row.pjyh - scope.row.youhao).toFixed(2)>30||(scope.row.pjyh - scope.row.youhao).toFixed(2)<-30?'red':'black')}]">{{(scope.row.pjyh - scope.row.youhao).toFixed(2)}}</span>
                    </template>
                </el-table-column>

                <el-table-column 
                    width="130"
                    prop="chepai_1"
                    label="类型">
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { carListAll,bblist2 } from '../router/api';

export default {
    data() {
        return {
            date:'',
            list: [],
            show: false,
            minDate: new Date(2023, 1, 1),
            org:'',
            heji_you:0,
            heji_licheng:0,
            heji_cishu:0,
            time1:'',
            time2:'',
            carnum_jiayou:'',
            temp: true,
            tableData:[],
            carnum:0,
        }; 
    },
  
    async mounted() {
        this.org = this.$route.query.org
        this.carnum = this.$route.query.carnum
        var date = new Date();
        date.setTime(date.getTime());
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
        var time1 = Y + M + '01'
        var time2 = Y + M +D
        this.date = time1 + ' - ' + time2 

        await this.getList2()
        await this.getList()    
    },
    methods: {

        formatDate(date) {
            var Y = date.getFullYear() + "-"; 
            var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var day =  Y + M + D
            return day
        },

        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            this.getList()
        },

        async getList2() {
            carListAll({
                id:'',
                chepai:'',
                xz_status:'',
                gongsi:this.org,
                shu_gongsi:''
            }).then(res=> {
                if(res.code==1) {
                    this.tableData = res.data
                    this.carnum = res.data.length
                }
            }).catch(err=> {
                console.log(err);
            });
        },

        async getList() {
            this.time1 = this.date.split(' - ')[0] + ' 00:00:00'
            this.time2 = this.date.split(' - ')[1] + ' 23:59:59'
            await bblist2({
                s_time: this.time1,
                e_time: this.time2,
                status: 1, //是否审核
                org:this.org,
            }).then(res=> {
                this.heji_you = 0;
                this.heji_licheng = 0;
                this.heji_cishu = 0;
                this.list = [];
                if(res.code==1) {
                    this.carnum_jiayou = res.data.length
                    this.list = res.data
                    this.list.map(item=>{
                        item.all_licheng = item.all_licheng.toFixed(2)
                        item.all_shengshu = item.all_shengshu.toFixed(2)
                        if(item.pjyh) {
                            item.pjyh = item.pjyh.toFixed(2)
                        }
                        item.all_shengshu = Number(item.all_shengshu)
                        item.all_licheng = Number(item.all_licheng)
                        item.cishu = Number(item.cishu)
                        this.heji_you += item.all_shengshu
                        this.heji_licheng += item.all_licheng
                        this.heji_cishu += item.cishu    
                    })

                    this.tableData.map(item=> {
                        this.list.push({
                            chepai:item.chepai,
                            xz_status:item.xz_status,
                            cishu:0,
                            all_licheng:0,
                            all_shengshu:0,
                            youhao:item.youhao,
                            pjyh:item.youhao,
                            chepai_1:item.type,
                        })
                    })

                    this.list.push({
                        chepai:'合计',
                        cishu:this.heji_cishu,
                        all_licheng:this.heji_licheng,
                        all_shengshu:this.heji_you.toFixed(2),
                        youhao:'',
                        pjyh:'',
                    })

                    for(var i=0; i<this.list.length;i++) {
                        for(var j=i+1;j<this.list.length;j++) {
                            if(this.list[i].chepai==this.list[j].chepai) {
                                this.list.splice(j,1);
                                j--;
                            }
                        }
                    }
                 
                   
                }

            }).catch(err=> {
                console.log(err);
            });
        },

        daoChu() {
            var wb = XLSX.utils.table_to_book(document.querySelector('#outTable'))
            var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
            try {
                FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
            } catch(e) {
                if (typeof console !== 'undefined')
                console.log(e, wbout)
            }
            return wbout
        },

        go(row) {
            this.$router.push(`/bblist2?org=${this.org}&time1=${this.time1}&time2=${this.time2}&chepai=${row.chepai}`);
        },
        renderHeader1() {
            return (
                <div>
                    <span onClick={this.pai1}>次数</span>
                </div>
            )
        },
        renderHeader2() {
            return (
                <div>
                    <span onClick={this.pai2}>总升数</span>
                </div>
            )
        },
        renderHeader3() {
            return (
                <div>
                    <span onClick={this.pai3}>总里程</span>
                </div>
            )
        },
        renderHeader4() {
            return (
                <div>
                    <span onClick={this.pai4}>差异</span>
                </div>
            )
        },

        pai1() {
            this.temp = !this.temp;
            var flag = this.list.pop()
            if (this.temp) {
                this.list.sort(function (x, y) {
                    return y.cishu - x.cishu;
                });
            } else {
                this.list.sort(function (x, y) {
                    return x.cishu - y.cishu;
                });
            }
            this.list.push(flag);
        },

        pai2() {
            this.temp = !this.temp;
            var flag = this.list.pop()
            if (this.temp) {
                this.list.sort(function (x, y) {
                    return y.all_shengshu - x.all_shengshu;
                });
            } else {
                this.list.sort(function (x, y) {
                    return x.all_shengshu - y.all_shengshu;
                });
            }
            this.list.push(flag);
        },

        pai3() {
            this.temp = !this.temp;
            var flag = this.list.pop()
            if (this.temp) {
                this.list.sort(function (x, y) {
                    return y.all_licheng - x.all_licheng;
                });
            } else {
                this.list.sort(function (x, y) {
                    return x.all_licheng - y.all_licheng;
                });
            }
            this.list.push(flag);
        },

        pai4() {
            this.temp = !this.temp;
            var flag = this.list.pop()
            if (this.temp) {
                this.list.sort(function (x, y) {
                    return ((y.pjyh - y.youhao).toFixed(2)) - ((x.pjyh - x.youhao).toFixed(2));
                });
            } else {
                this.list.sort(function (x, y) {
                    return ((x.pjyh - x.youhao).toFixed(2)) - ((y.pjyh - y.youhao).toFixed(2));
                });
            }
            this.list.push(flag);
        },
    },
};
</script>
<style lang="less" scoped>
.bblist .el-table {
    border: solid 1px black;
}
.bblist h4 {
    display: flex;
    justify-content: space-between;
}
</style>


